let debounce = function (func, wait, immediate?) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
    if (immediate && !timeout) func.apply(context, args);
  };
};

class ProplusAjaxSearch {
  options = {
    searchUrl: "/api/search",
    resultTemplate: ".result-template",
    searchField: ".search-field",
    resultsContainer: ".results",
    messagesContainer: ".messages",
    debounceDelay: 200,
    filterQuery: <any>null,
  };

  elements: any = {};

  searchData: {} = {};
  currentXhr: any;
  resultTemplate = "";

  searchDebounced: Function;
  _status = "initial";
  get status() {
    return this._status;
  }
  set status(value) {
    this._status = value;

    this.elements.main.attr("data-status", this._status);
  }
  constructor(target, options) {
    let that = this;
    if (options) Object.assign(this.options, options);

    this.elements.main = jQuery(target);

    this.resultTemplate = this.elements.main
      .find(this.options.resultTemplate)
      .html();
    this.elements.searchField = this.elements.main.find(
      this.options.searchField
    );
    this.elements.resultsContainer = this.elements.main.find(
      this.options.resultsContainer
    );
    this.elements.messagesContainer = this.elements.main.find(
      this.options.messagesContainer
    );

    this.searchDebounced = debounce(this.search, this.options.debounceDelay);

    this.elements.searchField.on("input", function () {
      that.searchDebounced();
    });

    let defaultValue = new URL(window.location.href).searchParams.get("query");
    this.elements.searchField.val(defaultValue);
    if (defaultValue) {
      this.searchDebounced();
    }

    this.status = "initial";
  }
  renderResults(results) {
    let rendered = [];
    for (let id in results) {
      let row = results[id];
      let template = this.resultTemplate;
      for (let key in row) {
        let value = row[key];
        template = template.split("{" + key + "}").join(value ? value : "");
      }

      rendered.push(template);
    }

    return jQuery(rendered.join("\n"));
  }

  search() {
    var that = this;
    if (this.currentXhr) {
      this.currentXhr.abort();
      this.currentXhr = null;
    }

    this.status = "loading";
    let queryString = encodeURI(this.getSearchString());
    let query = {
      searchString: this.getSearchString(),
      baseUrl: this.options.searchUrl,
      path: queryString,
    };

    if (this.options.filterQuery) query = this.options.filterQuery(query);

    let xhr = jQuery
      .ajax(query.baseUrl + "/" + query.path, {
        method: "get",
        dataType: "json",
      })
      .done(function (data) {
        console.log(data);
        //autocomplete.hide();
        that.currentXhr = null;

        let rendered = that.renderResults(data.results);
        that.elements.resultsContainer.html(rendered);
        if (data.count === 0) that.status = "no-results";
        else if (data.truncated) that.status = "truncated";
        else that.status = "idle";
      });
  }

  getSearchString() {
    return this.elements.searchField.val();
  }

  clearResults() {}
}
